import { render, staticRenderFns } from "./DeckSettingsModal.vue?vue&type=template&id=ac3ef36c&scoped=true"
import script from "./DeckSettingsModal.vue?vue&type=script&lang=js"
export * from "./DeckSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./DeckSettingsModal.vue?vue&type=style&index=0&id=ac3ef36c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3ef36c",
  null
  
)

export default component.exports